'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _commonjsHelpers = require('../../_commonjsHelpers-6ecf82ef.js');
require('../../extends-733dd656.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
var taggedTemplateLiteral = require('../../taggedTemplateLiteral-f923b98d.js');
require('styled-components');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../unsupportedIterableToArray-f175acfa.js');
var styles_breakpoints = require('../../breakpoints-ee0a4ae5.js');
require('../GlobalStyle/GlobalStyle.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
var styles_theme = require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
var components_NuDSProvider_NuDSProvider = require('../NuDSProvider/NuDSProvider.js');
var slicedToArray = require('../../slicedToArray-a8a77f0e.js');
var utils_isType_isType = require('../../utils/isType/isType.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _typeof_1 = _commonjsHelpers.createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
});

var isExternalImageSource = function isExternalImageSource() {
  var imageSource = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return imageSource.startsWith('http');
};

var breakpoints = styles_theme.theme.breakpoints;
var breakpointsNames = Object.keys(breakpoints).reverse();
var pixelDensities = ['1x', '2x', '3x'];

function createSource() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var pixelDensity = arguments.length > 1 ? arguments[1] : undefined;

  if (pixelDensity) {
    return {
      path: path,
      pixelDensity: pixelDensity
    };
  }

  return {
    path: path
  };
}

function createBreakPointWithSources(providedSourceForBreakpoint, breakPointValue) {
  var firstFoundPixelDensityProvidedSource = Object.keys(providedSourceForBreakpoint)[0];
  var firstSourcePath = providedSourceForBreakpoint[firstFoundPixelDensityProvidedSource];
  return {
    breakPointValue: breakPointValue,
    isExternal: isExternalImageSource(firstSourcePath),
    sources: pixelDensities.reduce(function (acc, pixelDensity) {
      var pixelDensitySource = providedSourceForBreakpoint[pixelDensity];
      if (!pixelDensitySource) return acc;
      return [].concat(styles_breakpoints.toConsumableArray(acc), [createSource(pixelDensitySource, pixelDensity)]);
    }, [])
  };
}

function createBreakPointWithSource(providedSourceForBreakpoint, breakPointValue) {
  var source = createSource(providedSourceForBreakpoint);
  return {
    isExternal: isExternalImageSource(source.path),
    breakPointValue: breakPointValue,
    source: source
  };
}

function getSmallerSourcePathFrom(sourcesToRenderByBreakpoint) {
  var _sourcesToRenderByBre, _sourcesToRenderByBre2, _sourcesToRenderByBre3;

  var smallerSourceIndex = sourcesToRenderByBreakpoint.length - 1;
  var smallerImageFromSource = (_sourcesToRenderByBre = sourcesToRenderByBreakpoint[smallerSourceIndex]) === null || _sourcesToRenderByBre === void 0 ? void 0 : _sourcesToRenderByBre.source;
  var smallerImageFromSources = ((_sourcesToRenderByBre2 = sourcesToRenderByBreakpoint[smallerSourceIndex]) === null || _sourcesToRenderByBre2 === void 0 ? void 0 : _sourcesToRenderByBre2.sources) && ((_sourcesToRenderByBre3 = sourcesToRenderByBreakpoint[smallerSourceIndex]) === null || _sourcesToRenderByBre3 === void 0 ? void 0 : _sourcesToRenderByBre3.sources[0]);
  return (smallerImageFromSource === null || smallerImageFromSource === void 0 ? void 0 : smallerImageFromSource.path) || (smallerImageFromSources === null || smallerImageFromSources === void 0 ? void 0 : smallerImageFromSources.path);
}
function prepareSourcesToRender() {
  var srcSet = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    xl: '',
    lg: '',
    md: '',
    sm: '',
    xs: ''
  };
  return breakpointsNames.reduce(function (accSources, breakpointName) {
    var providedSourceForBreakpoint = srcSet[breakpointName];
    var hasProvidedSourceForBreakpoint = Boolean(providedSourceForBreakpoint);
    var breakPointValue = breakpoints[breakpointName];
    if (!hasProvidedSourceForBreakpoint) return accSources;
    var hasMultiSourcesForCurrentBreakpoint = _typeof_1(providedSourceForBreakpoint) === 'object';

    if (hasMultiSourcesForCurrentBreakpoint) {
      return [].concat(styles_breakpoints.toConsumableArray(accSources), [createBreakPointWithSources(providedSourceForBreakpoint, breakPointValue)]);
    }

    return [].concat(styles_breakpoints.toConsumableArray(accSources), [createBreakPointWithSource(providedSourceForBreakpoint, breakPointValue)]);
  }, []);
}

var avaiableTypes = new Set(['webp']);
function imageSourceResolver(imageSource) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    type: '',
    requireImage: components_NuDSProvider_NuDSProvider.requireImageFunctionDefault
  },
      type = _ref.type,
      requireImage = _ref.requireImage;

  var hasType = Boolean(type);
  var isValidType = avaiableTypes.has(type);
  var isExternalImg = isExternalImageSource(imageSource);

  if (hasType && !isExternalImg) {
    if (!isValidType) {
      throw new Error('You must proivde a valid type');
    }

    return requireImage(imageSource, type);
  }

  return isExternalImg ? imageSource : requireImage(imageSource);
}

function _templateObject() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n  display: block;\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var width = xstyledStyledComponents_es.style({
  prop: 'width'
});
var height = xstyledStyledComponents_es.style({
  prop: 'height'
});
var maxWidth = xstyledStyledComponents_es.style({
  prop: 'maxWidth'
});
var objectFit = xstyledStyledComponents_es.style({
  prop: 'objectFit'
});
var objectPosition = xstyledStyledComponents_es.style({
  prop: 'objectPosition'
});
var styleProps = xstyledStyledComponents_es.compose(width, height, maxWidth, objectFit, objectPosition);
var SystemImage = xstyledStyledComponents_es.createSystemComponent(React__default['default'], 'img', styleProps);
var ImageWrapper = xstyledStyledComponents_es.styled(SystemImage)(_templateObject(), styleProps);
ImageWrapper.displayName = 'ImageWrapper';

function _templateObject6() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n        ", "\n      "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n      @media\n      only screen and (-webkit-min-device-pixel-ratio: ", "),\n      only screen and (        min-device-pixel-ratio: ", "),\n      only screen and (                min-resolution: ", "dpi),\n      only screen and (                min-resolution: ", "dppx) {\n        ", "\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    ", "\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n    background-image: url('", "');\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n      background-image: url('", "');\n    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n      background-image: none;\n    "]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var handleBackground = function handleBackground(imagePath) {
  var _useContext = React.useContext(components_NuDSProvider_NuDSProvider.NuDsContext),
      requireImageFunction = _useContext.requireImageFunction;

  var isImagePathNone = imagePath === 'none';

  if (isImagePathNone) {
    return xstyledStyledComponents_es.css(_templateObject$1());
  }

  if (isExternalImageSource(imagePath)) {
    return xstyledStyledComponents_es.css(_templateObject2(), imagePath);
  }

  return xstyledStyledComponents_es.css(_templateObject3(), requireImageFunction(imagePath));
};

function createDPR(dpr) {
  return {
    pixelRatio: dpr,
    dpi: 96 * dpr,
    ddpx: dpr
  };
}

var DPRValuesByDensity = {
  '1x': createDPR(1),
  '2x': createDPR(2),
  '3x': createDPR(3)
};

function handlePixelRatioBreakpoints(srcSetDPR) {
  var has1xImage = srcSetDPR['1x'];

  if (!has1xImage) {
    throw new Error('You must provide the "1x" image to be used as default');
  }

  var breakpointDPRs = Object.entries(srcSetDPR);
  return xstyledStyledComponents_es.css(_templateObject4(), breakpointDPRs.map(function (_ref) {
    var _ref2 = slicedToArray.slicedToArray(_ref, 2),
        currentDPR = _ref2[0],
        currentImagePath = _ref2[1];

    var currentDensityDPRValues = DPRValuesByDensity[currentDPR];
    return xstyledStyledComponents_es.css(_templateObject5(), currentDensityDPRValues.pixelRatio, currentDensityDPRValues.pixelRatio, currentDensityDPRValues.dpi, currentDensityDPRValues.ddpx, handleBackground(currentImagePath));
  }));
}

function handleBackgroundWithDPR(srcSetItem) {
  var isPixelRatioBreakpointPath = !utils_isType_isType.isType('string', srcSetItem);
  return isPixelRatioBreakpointPath ? handlePixelRatioBreakpoints(srcSetItem) : handleBackground(srcSetItem);
}

var backgroundImage = function backgroundImage(srcSet) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return function () {
    var _useContext2 = React.useContext(components_NuDSProvider_NuDSProvider.NuDsContext),
        backgroundImageFunction = _useContext2.backgroundImageFunction;

    var hasBackgroundImageFunction = Boolean(backgroundImageFunction);

    if (hasBackgroundImageFunction) {
      return backgroundImageFunction.apply(void 0, [srcSet].concat(args));
    }

    if (utils_isType_isType.isType('string', srcSet)) {
      return handleBackground(srcSet);
    }

    return styles_breakpoints.breakpointsMedia(Object.fromEntries(Object.entries(srcSet).map(function (_ref3) {
      var _ref4 = slicedToArray.slicedToArray(_ref3, 2),
          key = _ref4[0],
          set = _ref4[1];

      return [key, xstyledStyledComponents_es.css(_templateObject6(), handleBackgroundWithDPR(set))];
    })));
  };
};

function srcSetReducerFor(imageType, requireImageFn) {
  return function (acc, source, index, arr) {
    var isLastItem = arr.length - 1 === index;
    return "".concat(acc).concat(imageSourceResolver(source.path, {
      type: imageType,
      requireImage: requireImageFn
    }), " ").concat(source.pixelDensity).concat(!isLastItem ? ',' : '');
  };
}

var srcSetReducerDefault = function srcSetReducerDefault(requireImageFn) {
  return srcSetReducerFor('', requireImageFn);
};

var srcSetReducerWebp = function srcSetReducerWebp(requireImageFn) {
  return srcSetReducerFor('webp', requireImageFn);
};

function Image(_ref) {
  var alt = _ref.alt,
      altIntlKey = _ref.altIntlKey,
      className = _ref.className,
      loading = _ref.loading,
      importance = _ref.importance,
      src = _ref.src,
      srcSet = _ref.srcSet,
      webp = _ref.webp,
      title = _ref.title,
      titleIntlKey = _ref.titleIntlKey,
      width = _ref.width,
      height = _ref.height,
      maxWidth = _ref.maxWidth,
      objectFit = _ref.objectFit,
      objectPosition = _ref.objectPosition;

  var _useContext = React.useContext(components_NuDSProvider_NuDSProvider.NuDsContext),
      formatMessage = _useContext.formatMessage,
      requireImageFunction = _useContext.requireImageFunction;

  var altValue = alt || formatMessage({
    id: altIntlKey
  });
  var hasTitle = title || titleIntlKey;
  var titleValue = hasTitle ? title || formatMessage({
    id: titleIntlKey
  }) : null;
  var sourcesToRenderByBreakpoint = prepareSourcesToRender(srcSet);
  var baseFileSourcePath = src || getSmallerSourcePathFrom(sourcesToRenderByBreakpoint);
  return /*#__PURE__*/React__default['default'].createElement("picture", null, sourcesToRenderByBreakpoint.map(function (_ref2) {
    var breakPointValue = _ref2.breakPointValue,
        source = _ref2.source,
        sources = _ref2.sources,
        isExternal = _ref2.isExternal;
    return /*#__PURE__*/React__default['default'].createElement(React.Fragment, {
      key: breakPointValue
    }, webp && !isExternal && /*#__PURE__*/React__default['default'].createElement("source", {
      media: "(min-width:".concat(breakPointValue, "px)"),
      type: "image/webp",
      srcSet: source ? imageSourceResolver(source.path, {
        type: 'webp',
        requireImage: requireImageFunction
      }) : sources.reduce(srcSetReducerWebp(requireImageFunction), '')
    }), /*#__PURE__*/React__default['default'].createElement("source", {
      media: "(min-width:".concat(breakPointValue, "px)"),
      srcSet: source ? imageSourceResolver(source.path, {
        requireImage: requireImageFunction
      }) : sources.reduce(srcSetReducerDefault(requireImageFunction), '')
    }));
  }), webp && !isExternalImageSource(baseFileSourcePath) && /*#__PURE__*/React__default['default'].createElement("source", {
    type: "image/webp",
    srcSet: imageSourceResolver(baseFileSourcePath, {
      type: 'webp',
      requireImage: requireImageFunction
    })
  }), /*#__PURE__*/React__default['default'].createElement(ImageWrapper, {
    src: imageSourceResolver(baseFileSourcePath, {
      requireImage: requireImageFunction
    }),
    alt: altValue,
    className: className,
    loading: loading,
    importance: importance,
    title: titleValue,
    width: width,
    height: height,
    maxWidth: maxWidth,
    objectFit: objectFit,
    objectPosition: objectPosition
  }));
}

Image.defaultProps = {
  alt: '',
  altIntlKey: '',
  className: '',
  loading: 'auto',
  importance: 'auto',
  webp: true,
  srcSet: {},
  src: '',
  title: '',
  titleIntlKey: '',
  width: '100%',
  height: 'auto',
  maxWidth: '100%',
  objectFit: undefined,
  objectPosition: ''
};
var DPRPropTypes = index.propTypes.shape({
  '1x': index.propTypes.string.isRequired,
  '2x': index.propTypes.string,
  '3x': index.propTypes.string
});
var imageShape = {
  alt: index.propTypes.string,
  altIntlKey: index.propTypes.string,
  className: index.propTypes.string,
  height: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  importance: index.propTypes.oneOf(['high', 'low', 'auto']),
  loading: index.propTypes.oneOf(['lazy', 'eager', 'auto']),
  maxWidth: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  objectFit: index.propTypes.oneOfType([index.propTypes.oneOf(['fill', 'contain', 'cover', 'none', 'scale-down']), index.propTypes.object]),
  objectPosition: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.object]),
  srcSet: index.propTypes.shape({
    /* eslint-disable react/sort-prop-types */
    xl: index.propTypes.oneOfType([index.propTypes.string, DPRPropTypes]),
    lg: index.propTypes.oneOfType([index.propTypes.string, DPRPropTypes]),
    md: index.propTypes.oneOfType([index.propTypes.string, DPRPropTypes]),
    sm: index.propTypes.oneOfType([index.propTypes.string, DPRPropTypes]),
    xs: index.propTypes.oneOfType([index.propTypes.string, DPRPropTypes])
    /* eslint-disable react/sort-prop-types */

  }),
  src: index.propTypes.string,
  title: index.propTypes.string,
  titleIntlKey: index.propTypes.string,
  webp: index.propTypes.bool,
  width: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object])
};
Image.propTypes = imageShape;
var Image$1 = /*#__PURE__*/React__default['default'].memo(Image);

exports.backgroundImage = backgroundImage;
exports.default = Image$1;
exports.imageShape = imageShape;
//# sourceMappingURL=Image.js.map
